namespace('compass.group');

compass.group.ConfirmGroupMembersWidget = compass.defineWidget(function confirmGroupMembersWidget(options) {
	
	var me = this;
	var $j = jQuery;
	var d = $j.dom.getContext(this);
	var _settings = options;
	
	this.render = function(widgetElem) {
		widgetElem.append(d.div({ className : 'confirmContainer' },
			d.div({ className : 'title'}, 'Confirm All Members'),
			d.div({ className : 'confirmInstructions'}, 'Every reservation with a unique email address will receive an individual group member confirmation.'),
			d.button({ className : 'confirmButton button'}, 'Send Confirmations')
		));
		
		me.find('.button').activate(confirmButtonClicked);
	};

	var confirmButtonClicked = function() {
		me.trigger(CompassEvents.SendConfirmation);
	};
}, {
	WUID : 'defaultConfirmGroupMembersWidgetGUID',
	widgetName : 'ConfirmGroupMembersWidget'
});
